export enum MobileAppsEnum {
  trueview = 1,
}
